import { z } from 'zod';

export const LIBRARY_FILTERS = ['all', 'toConfirm'] as const;
export type LibraryFilter = (typeof LIBRARY_FILTERS)[number];

export const MACHINE_FILTERS = ['all', 'needs', 'maintenance', 'custom'] as const;
export type MachineFilter = (typeof MACHINE_FILTERS)[number];

export const SYNC_VIEWS = ['types', 'machines'] as const;
export type SyncView = (typeof SYNC_VIEWS)[number];

const FIRST_PAGE = 1;

export const searchTextSchema = z.string().trim().catch('');

const shownOnlyWhenTrue = z
  .string()
  .transform((value) => value === 'true')
  .catch(false);

const wholePage = z.coerce.number().int().min(FIRST_PAGE).catch(FIRST_PAGE);

export const librarySearchSchema = z.object({
  q: searchTextSchema,
  filter: z.enum(LIBRARY_FILTERS).catch('all'),
});
export type LibrarySearch = z.output<typeof librarySearchSchema>;
export const LIBRARY_SEARCH_DEFAULTS: LibrarySearch = { q: '', filter: 'all' };

export const vocabularySearchSchema = z.object({
  q: searchTextSchema,
});
export type VocabularySearch = z.output<typeof vocabularySearchSchema>;
export const VOCABULARY_SEARCH_DEFAULTS: VocabularySearch = { q: '' };

export const machineSearchSchema = z.object({
  q: searchTextSchema,
  type: searchTextSchema,
  filter: z.enum(MACHINE_FILTERS).catch('all'),
  archived: shownOnlyWhenTrue,
  page: wholePage,
});
export type MachineSearch = z.output<typeof machineSearchSchema>;
export const MACHINE_SEARCH_DEFAULTS: MachineSearch = { q: '', type: '', filter: 'all', archived: false, page: FIRST_PAGE };

export const syncSearchSchema = z.object({
  view: z.enum(SYNC_VIEWS).catch('types'),
});
export type SyncSearch = z.output<typeof syncSearchSchema>;
export const SYNC_SEARCH_DEFAULTS: SyncSearch = { view: 'types' };
